import React from 'react';
import { usePreferencesStore } from '../../store/preferencesStore';
import { Toggle, Row, Section } from '../settingsPrimitives';
import LaunchAtLoginToggle from './LaunchAtLoginToggle';

export const NotificationsTab = ({ t, desktopApp }) => {
  const desktopNotifications = usePreferencesStore((s) => s.desktopNotifications);
  const notificationSound    = usePreferencesStore((s) => s.notificationSound);
  const closeToTray          = usePreferencesStore((s) => s.closeToTray);
  const update               = usePreferencesStore((s) => s.updatePreference);

  return (
    <>
      <Section title={t('settings.notificationsChat')}>
        <Row label={t('settings.desktopNotifications')} desc={t('settings.desktopNotificationsDesc')}>
          <Toggle value={desktopNotifications} onChange={(v) => update('desktopNotifications', v)} />
        </Row>
        <Row label={t('settings.notificationSound')} desc={t('settings.notificationSoundDesc')}>
          <Toggle value={notificationSound} onChange={(v) => update('notificationSound', v)} />
        </Row>
      </Section>

      {desktopApp && (
        <Section title={t('settings.notificationsWindow')}>
          <Row label={t('settings.keepInTray')} desc={t('settings.keepInTrayDesc')}>
            <Toggle value={closeToTray} onChange={(v) => update('closeToTray', v)} />
          </Row>
          <Row label={t('settings.openAtLogin')} desc={t('settings.openAtLoginDesc')}>
            <LaunchAtLoginToggle />
          </Row>
        </Section>
      )}
    </>
  );
};
